import { getPatients } from 'services/user';
import { queryKeys, queryParams } from 'utils/query';
import { PatientHasMeasurement, PatientProfile, PatientStatus } from 'utils/models';
import { TableBody } from 'components/Table/TableBody/TableBody';
import { PatientsTableColumns } from 'components/Table/Columns/PatientsListColumns';
import { PatientsListFilters } from 'components/Table/Filters/PatientsListFilters';
import { TableConfig } from 'models/general';
import { DataFieldNames } from './PatientsTable.config';

const patientsListConfig: TableConfig = {
  queryKey: queryKeys.patients,
  dataFieldNames: DataFieldNames,
  defaultFilters: {
    [queryParams.status]: PatientStatus.All,
    [queryParams.hasMeasurement]: PatientHasMeasurement.All,
  },
  defaultSort: `-${DataFieldNames.lastName}`,
};

export const PatientsTable = () => {
  return (
    <TableBody<PatientProfile>
      getData={getPatients}
      getColumns={PatientsTableColumns}
      config={patientsListConfig}
      filterBar={<PatientsListFilters config={patientsListConfig} />}
    />
  );
};
